import React from "react";

const Referral = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        R.
        <span className="text-[#01A7D1] ">
          {" "}
          Referral Count and Payout Terms
        </span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        1. No TDS will be deducted for payouts for the first Rs. 10,000.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        2. Post Rs. 10,000 cumulative payouts, you can opt to either continue
        receiving money in your account/ wallet with 20% TDS deductions or
        update your PAN card details.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        3. Post the verification of PAN card, 3.75% TDS will be deducted for
        every successive payout.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        4. Please note that the first payout beyond Rs. 10,000 will account for
        TDS cut for the first Rs. 10,000 as well.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        5. All or any payouts will be done as per the levels mentioned in the
        application at the time of referral lead are submitted
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        6. Those Referral leads already available with Yostel’s database shall
        not be eligible for any referral payouts.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        7. All referral payouts shall be subject to Yostel's ethical guidelines
        and any suspicious activity shall be flagged. Yostel also retains the
        right to initiate appropriate action against any such activity and/or
        person.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        8. Yostel reserves the right to change the Terms and Conditions and/or
        the Payout policy at its own discretion.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        9. The approval or decline of Referral Payouts shall be subject to the
        final decision of Yostel at all times.
      </p>
    </div>
  );
};

export default Referral;
